import React from 'react';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';

import {ChartColumn, OverviewChartSideMenu, ChartLegend} from './components';

import {withScrollbar} from 'components/withScrollbar';
import ButtonSwitch from 'components/ButtonSwitch';

import {REPORT_SHAPE, TOTAL, OCCUPANCY_TYPE_CHOICES} from 'ducks/occupancy';
import Tooltip from 'components/Tooltip';

import './styles.css';

const selectReportShapeOptions = choice => {
  let options = [
    {label: REPORT_SHAPE.BOOKING_TYPE.label, value: REPORT_SHAPE.BOOKING_TYPE},
    {label: REPORT_SHAPE.ROOM_STATUS.label, value: REPORT_SHAPE.ROOM_STATUS},
    {label: REPORT_SHAPE.ROOM_PURPOSE.label, value: REPORT_SHAPE.ROOM_PURPOSE}
  ];
  if (choice === OCCUPANCY_TYPE_CHOICES.REVENUE_OCCUPANCY) {
    return options.slice(0, -1);
  }
  return options;
};

const ChartBarTooltip = ({unitsRenderer}) => (
  <Tooltip
    place="right"
    type="dark"
    effect="solid"
    id="ChartBar__tooltip"
    className="ChartBar__tooltip"
    getContent={stringifiedData => {
      const data = stringifiedData && JSON.parse(stringifiedData);
      const shouldRender = !_.isEmpty(data);

      return (
        shouldRender &&
        data.map(row => (
          <div className="colab-row-space-between" key={row.label}>
            <div className="ChartBar__tooltip__label">{row.label}</div>
            <div className="colab-bold">
              {unitsRenderer(row.value, row.maxValue)}
            </div>
          </div>
        ))
      );
    }}
  />
);

const ChartSideMenuTooltip = () => (
  <Tooltip
    place="right"
    type="dark"
    effect="solid"
    id="ChartSideMenu__tooltip"
    className="ChartSideMenu__tooltip"
    getContent={stringifiedData => {
      const data = stringifiedData && JSON.parse(stringifiedData);
      const shouldRender = !_.isEmpty(data);

      return (
        shouldRender && (
          <div className="">
            <div className="">{data.label}</div>
            {data.totalRooms && (
              <div className="">
                {data.totalRooms} rooms at {data.date}
              </div>
            )}
          </div>
        )
      );
    }}
  />
);

class OverviewChart extends React.Component<any> {
  chartRef: any = React.createRef();

  state = {
    isScrolling: false,
    startX: 0,
    currentScrollLeft: 0
  };

  componentDidMount() {
    // required for withScrollbar
    this.props.setScrollableContainerRef(this.chartRef.current);
  }

  onMouseLeave = () => this.setState({isScrolling: false});
  onMouseUp = () => this.setState({isScrolling: false});

  onMouseDown = event =>
    this.setState({
      isScrolling: true,
      startX: event.pageX,
      currentScrollLeft: this.chartRef.current.scrollLeft
    });

  onMouseMove = event => {
    if (this.state.isScrolling) {
      event.persist();
      event.preventDefault();

      const offset = event.pageX - this.state.startX;

      this.chartRef.current.scrollLeft = this.state.currentScrollLeft - offset;
    }
  };

  render() {
    const {
      disableShapeSwitch,
      elementsList,
      tableHeaderData,
      unitsRenderer,
      resolution,
      openedNestedGroups,
      toggleNestedGroup,
      toggleShapeRenderer,
      segments,
      currentShape,
      HorizontalScrollbar,
      occupancyChoice
    } = this.props;

    ReactTooltip.rebuild();

    return (
      <div className="OverviewChart">
        <OverviewChartSideMenu
          totalRooms={_.round(
            _.get(elementsList, `[0].tableData[${TOTAL}].displayValue`, 0)
          )}
          tableHeaderData={tableHeaderData}
          toggleNestedGroup={toggleNestedGroup}
          openedNestedGroups={openedNestedGroups}
          unitsRenderer={unitsRenderer}
          firstDate={!_.isEmpty(elementsList) && elementsList[0].date}
        />
        <div className="OverviewChart__chart">
          <div className="OverviewChart__switchContainer colab-centered">
            <ButtonSwitch
              options={selectReportShapeOptions(occupancyChoice)}
              initialValue={currentShape}
              disabled={disableShapeSwitch}
              onChange={chosenValue => toggleShapeRenderer(chosenValue.value)}
            />
          </div>
          <div className="OverviewChart__chart__scala">
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
          <div className="OverviewChart__chart__references colab-centered">
            {segments.map(segment => (
              <ChartLegend key={segment.value} segment={segment} />
            ))}
          </div>
          <div
            className="OverviewChart__chart__container"
            onMouseDown={this.onMouseDown}
            onMouseUp={this.onMouseUp}
            onMouseMove={this.onMouseMove}
            onMouseLeave={this.onMouseLeave}
            ref={this.chartRef}>
            <div className="OverviewChart__chart__container__content">
              {elementsList.map(element => (
                <ChartColumn
                  key={element.uuid}
                  tableHeaders={tableHeaderData}
                  tableColumn={element}
                  resolution={resolution}
                  openedNestedGroups={openedNestedGroups}
                  segments={segments}
                  unitsRenderer={unitsRenderer}
                />
              ))}
            </div>
            {HorizontalScrollbar}
          </div>
          <ChartBarTooltip unitsRenderer={unitsRenderer} />
          <ChartSideMenuTooltip />
        </div>
      </div>
    );
  }
}

export default withScrollbar(OverviewChart, {vertical: false});
